import { ImageFit, ImageFormat, cdnService, getImagePath, ImageType, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var cssBreakpoints = [
    1920,
    1050,
    896,
    672,
    525,
    524, // Mobile
];
var heights = [
    1.1,
    1.3,
    1.5,
    2,
    2.5,
    3, // Mobile
];
var validImageFit = Object.values(ImageFit);
/**
 * Component is used to display responsive images.
 */
var BackgroundComponent = /** @class */ (function (_super) {
    __extends(BackgroundComponent, _super);
    function BackgroundComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.originalHeight = -1;
        _this.originalWidth = -1;
        return _this;
    }
    BackgroundComponent.prototype.created = function () {
        var _this = this;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var result, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.getPath({
                            format: ImageFormat.JSON,
                        }))];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, result.json()];
                    case 2:
                        json = _a.sent();
                        this.originalHeight = json.PixelHeight;
                        this.originalWidth = json.PixelWidth;
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    Object.defineProperty(BackgroundComponent.prototype, "customHeights", {
        get: function () {
            var _a, _b;
            if (this.heights) {
                return this.heights.split(',').map(function (height) { return parseFloat(height); });
            }
            if ((_a = this.magicConfig.uiBackgroundConfig) === null || _a === void 0 ? void 0 : _a.aspectRatio) {
                return (_b = this.magicConfig.uiBackgroundConfig) === null || _b === void 0 ? void 0 : _b.aspectRatio;
            }
            return heights;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundComponent.prototype, "customBreakpoints", {
        get: function () {
            var _a, _b;
            if (this.breakpoints) {
                return this.breakpoints
                    .split(',')
                    .map(function (breakpoint) { return parseInt(breakpoint, 10); });
            }
            if ((_a = this.magicConfig.uiBackgroundConfig) === null || _a === void 0 ? void 0 : _a.cssBreakpoints) {
                return (_b = this.magicConfig.uiBackgroundConfig) === null || _b === void 0 ? void 0 : _b.cssBreakpoints;
            }
            return cssBreakpoints;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundComponent.prototype, "customImgFit", {
        get: function () {
            var _a, _b;
            if (this.imgFit) {
                return this.imgFit;
            }
            if ((_a = this.magicConfig.uiBackgroundConfig) === null || _a === void 0 ? void 0 : _a.imgxFit) {
                return (_b = this.magicConfig.uiBackgroundConfig) === null || _b === void 0 ? void 0 : _b.imgxFit;
            }
            return ImageFit.CROP;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundComponent.prototype, "cdnPath", {
        get: function () {
            return this.getPath();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BackgroundComponent.prototype, "alternatives", {
        get: function () {
            var _this = this;
            var heights = this.customHeights;
            var breakpoints = this.customBreakpoints;
            if (this.originalHeight === -1) {
                return [];
            }
            var originalRatio = this.originalHeight / this.originalWidth;
            var alternatives = [];
            breakpoints.forEach(function (width, i) {
                [ImageFormat.AVIF, ImageFormat.WEBP].forEach(function (format) {
                    alternatives.push({
                        srcset: _this.dprSrcset(format, i === 0 ? _this.originalWidth : breakpoints[i - 1], i === 0
                            ? _this.originalHeight
                            : width * originalRatio * heights[i]),
                        mediaQuery: "(" + (i < breakpoints.length - 1 ? 'min' : 'max') + "-width: " + width + "px)",
                        type: "image/" + format,
                    });
                });
            });
            return alternatives;
        },
        enumerable: false,
        configurable: true
    });
    BackgroundComponent.prototype.dprSrcset = function (format, width, height) {
        var _this = this;
        return [1, 2]
            .map(function (i) {
            return _this.getPath({
                format: format,
                minWidth: width,
                minHeight: height,
                retina: i === 2,
                fit: _this.customImgFit,
            }) +
                ' ' +
                i +
                'x';
        })
            .join(', ');
    };
    BackgroundComponent.prototype.getPath = function (params) {
        return cdnService.getImageUrl(getImagePath(this.imageType, this.path), params);
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "path", void 0);
    __decorate([
        Prop({ type: String, default: ImageType.PAGE_BACKGROUND }),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "imageType", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "alt", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "heights", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "breakpoints", void 0);
    __decorate([
        Prop({
            type: String,
            validator: function (value) { return validImageFit.includes(value); },
        }),
        __metadata("design:type", String)
    ], BackgroundComponent.prototype, "imgFit", void 0);
    BackgroundComponent = __decorate([
        Component({
            name: 'ui-background',
        })
    ], BackgroundComponent);
    return BackgroundComponent;
}(Mixins(MagicConfigMixin)));

export default BackgroundComponent;
